import { render } from "./NavBar.vue?vue&type=template&id=51057f05&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=51057f05&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51057f05"

export default script